// store/slices/taxonomySlice.ts
import { TaxonomyState } from '../types';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: TaxonomyState = {
  selectedMainTaxonomy: 1,
  selectedChildTaxonomy: null,
};

const taxonomySlice = createSlice({
  name: 'taxonomy',
  initialState,
  reducers: {
    setSelectedMainTaxonomy: (state, action: PayloadAction<number>) => {
      state.selectedMainTaxonomy = action.payload;
    },
    setSelectedChildTaxonomy: (state, action: PayloadAction<number | null>) => {
      state.selectedChildTaxonomy = action.payload;
    },
  },
});

export const { setSelectedMainTaxonomy, setSelectedChildTaxonomy } =
  taxonomySlice.actions;
export default taxonomySlice.reducer;
